import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { datetimeFormat } from 'app/constants/date-time-format';
import { CalculationService, DateService } from 'app/services';

@Component({
  selector: 'app-clock',
  templateUrl: './clock.component.html',
  styleUrls: ['./clock.component.scss'],
})
export class ClockComponent implements OnInit, OnDestroy {
  @Input('datetime')
  set datetime(datetime: any) {
    if (datetime) {
      // this.milliseconds = new Date(datetime).getTime();
      this.milliseconds = datetime;
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.setDate();

      this.interval = setInterval(() => {
        // this.milliseconds += 1000;
        this.milliseconds = datetime.setSeconds(new Date().getSeconds());

        if (datetime.getSeconds() == 59 && datetime.getMinutes() != 59) {
          // this.milliseconds = datetime.setMinutes(datetime.getMinutes() + 1);
          this.milliseconds = datetime.setTime(datetime.getTime() + 1000);
        } else if (datetime.getSeconds() == 59 && datetime.getMinutes() == 59) {
          this.milliseconds = datetime.setTime(datetime.getTime() + 1000);
        }
        this.setDate();
      }, 1000);
    }
  }
  @Input() hours: any = 0;
  @Input() mins: any = 0;
  @Input() seconds: any = 0;
  @Input() startAt: any = '';
  @Input() endAt: any = '';
  @Input() showTimeLogPie: boolean = false;
  @Input() isAppswitch: boolean = false;
  @Input() handleClockStatusUpdate: (args: any) => void;
  @Input() isProcessing: boolean = false;
  @Input() tech: any = {};
  @Input() clockInTime: any = '';
  @Input() loggedHours: any = '';
  @Input() isMainApp: boolean = false;
  @Input() currentLang: string = 'en';

  @ViewChild('secondClockHand', { static: true }) secondClockHand: ElementRef;
  @ViewChild('minClockHand', { static: true }) minClockHand: ElementRef;
  @ViewChild('hourClockHand', { static: true }) hourClockHand: ElementRef;
  @ViewChild('innerClockFace', { static: true }) innerClockFace: ElementRef;
  @ViewChild('outerClockFace', { static: true }) outerClockFace: ElementRef;
  @ViewChild('clock', { static: true }) clock: ElementRef;
  @ViewChild('pie', { static: true }) pie: ElementRef;

  @ViewChild('secondClockHandAdmin', { static: true }) secondClockHandAdmin: ElementRef;
  @ViewChild('minClockHandAdmin', { static: true }) minClockHandAdmin: ElementRef;
  @ViewChild('hourClockHandAdmin', { static: true }) hourClockHandAdmin: ElementRef;
  @ViewChild('innerClockFaceAdmin', { static: true }) innerClockFaceAdmin: ElementRef;
  @ViewChild('outerClockFaceAdmin', { static: true }) outerClockFaceAdmin: ElementRef;
  @ViewChild('clockAdmin', { static: true }) clockAdmin: ElementRef;
  @ViewChild('pieAdmin', { static: true }) pieAdmin: ElementRef;

  time: string = '';
  date: string = '';
  day: string = '';
  interval: any = '';
  milliseconds: any;
  // milliseconds: number = 0;

  constructor(private dateService: DateService, private calculationService: CalculationService, private translate: TranslateService) { }

  ngOnInit() {
    this.translate.use(this.currentLang)
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  setDate() {
    const datetime = this.milliseconds;
    // const datetime = new Date();
    const [hours, mins, seconds] = this.dateService.formatDate(new Date(datetime), datetimeFormat.hhmmss).split(':');

    this.hours = hours;
    this.mins = mins;
    this.seconds = seconds;
    const secondsDegrees = (this.seconds / 60) * 360 + 90;
    this.secondClockHand.nativeElement.style.transform = `rotate(${secondsDegrees}deg)`;
    this.secondClockHandAdmin.nativeElement.style.transform = `rotate(${secondsDegrees}deg)`;

    const minsDegrees = (this.mins / 60) * 360 + (this.seconds / 60) * 6 + 90;
    this.minClockHand.nativeElement.style.transform = `rotate(${minsDegrees}deg)`;
    this.minClockHandAdmin.nativeElement.style.transform = `rotate(${minsDegrees}deg)`;

    const hourDegrees = (this.hours / 12) * 360 + (this.hours / 60) * 30 + 90;
    this.hourClockHand.nativeElement.style.transform = `rotate(${hourDegrees}deg)`;
    this.hourClockHandAdmin.nativeElement.style.transform = `rotate(${hourDegrees}deg)`;

    this.time = this.dateService.formatDate(datetime, datetimeFormat.hmma);
    this.date = this.dateService.formatDate(datetime, datetimeFormat.mmmmdyyyy,(this.currentLang === 'fr'?'fr':null));
    if (!this.isAppswitch) {
      this.day = this.dateService.formatDate(datetime, datetimeFormat.dddd.slice(0, 3));
    } else {
      this.day = this.dateService.formatDate(datetime, datetimeFormat.dddd.slice(0, 9));
    }

    if (this.showTimeLogPie) {
      const [sHours, sMins] = this.dateService.formatDate(new Date(this.startAt), datetimeFormat.hhmmss).split(':');
      const [eHours, eMins] = this.dateService.formatDate(new Date(this.endAt), datetimeFormat.hhmmss).split(':');
      const startAt = this.calculationService.roundOff((Number(sHours) * 60 + Number(sMins)) / 60);
      const endAt = this.calculationService.roundOff((Number(eHours) * 60 + Number(eMins)) / 60);
      const diff = endAt - startAt;
      let gradient = 'none';

      if (diff >= 12) {
        this.innerClockFace.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.innerClockFace.nativeElement.style.backgroundImage = gradient;
        this.outerClockFace.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.outerClockFace.nativeElement.style.backgroundImage = gradient;

        this.innerClockFaceAdmin.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.innerClockFaceAdmin.nativeElement.style.backgroundImage = gradient;
        this.outerClockFaceAdmin.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.outerClockFaceAdmin.nativeElement.style.backgroundImage = gradient;
      } else if (diff < 6) {
        gradient = `linear-gradient(${270 + 30 * startAt}deg, transparent 50%, white 50%), linear-gradient(${270 + 30 * endAt}deg, white 50%, transparent 50%)`;
        this.innerClockFace.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.innerClockFace.nativeElement.style.backgroundImage = gradient;
        this.outerClockFace.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.outerClockFace.nativeElement.style.backgroundImage = gradient;

        this.innerClockFaceAdmin.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.innerClockFaceAdmin.nativeElement.style.backgroundImage = gradient;
        this.outerClockFaceAdmin.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.outerClockFaceAdmin.nativeElement.style.backgroundImage = gradient;
      } else if (diff === 6) {
        gradient = `linear-gradient(90deg, white 50%, transparent 50%)`;
        this.innerClockFace.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.innerClockFace.nativeElement.style.backgroundImage = gradient;
        this.outerClockFace.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.outerClockFace.nativeElement.style.backgroundImage = gradient;

        this.innerClockFaceAdmin.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.innerClockFaceAdmin.nativeElement.style.backgroundImage = gradient;
        this.outerClockFaceAdmin.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.outerClockFaceAdmin.nativeElement.style.backgroundImage = gradient;
      } else {
        gradient = `linear-gradient(${90 + 30 * (endAt - 6)}deg, transparent 50%, var(--primary-500) 50%), linear-gradient(${90 + 30 * startAt}deg, white 50%, transparent 50%)`;
        this.innerClockFace.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.innerClockFace.nativeElement.style.backgroundImage = gradient;
        this.outerClockFace.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.outerClockFace.nativeElement.style.backgroundImage = gradient;

        this.innerClockFaceAdmin.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.innerClockFaceAdmin.nativeElement.style.backgroundImage = gradient;
        this.outerClockFaceAdmin.nativeElement.style.backgroundColor = 'var(--primary-500)';
        this.outerClockFaceAdmin.nativeElement.style.backgroundImage = gradient;
      }
    } else {
      this.innerClockFace.nativeElement.style.backgroundColor = '';
      this.innerClockFace.nativeElement.style.backgroundImage = '';
      this.outerClockFace.nativeElement.style.backgroundColor = '';
      this.outerClockFace.nativeElement.style.backgroundImage = '';

      this.innerClockFaceAdmin.nativeElement.style.backgroundColor = '';
      this.innerClockFaceAdmin.nativeElement.style.backgroundImage = '';
      this.outerClockFaceAdmin.nativeElement.style.backgroundColor = '';
      this.outerClockFaceAdmin.nativeElement.style.backgroundImage = '';
    }
  }
}
